import React from 'react';
import '../styles/Team.css';
import founderImg from '../assets/images/owner3.jpg';
import Header from '../components/Header';
import Footer from'../components/Footer';
 

const Team = () => {
  return (
    <div>
      <Header/>
  
    <div className="team-container">
      <h1>Meet Our Team</h1>
      <p className="team-intro">
        CyberKon is driven by a vision to blend construction and technology.
        Though the idea started with many contributors, today the effort continues
        with passion and dedication.
      </p>

      <div className="team-grid">
        <div className="team-member">
          <img src={founderImg} alt="Founder" />
          <h3>Abdulakeem Abdulafeez Kolawole</h3>
          <p className="role">Founder & Lead Developer</p>
          <p className="bio">
            Abdulafeez K. led the transformation of university-born ideas into this working platform,
            designing, developing, and deploying the estimation engine and web tools. Passionate
            about construction tech, coding, and practical solutions.
          </p>
        </div>
       <section className="careers-section">
  <h2>Join Our Mission</h2>
  <p>
    At CyberKon, we’re building tools that transform the construction industry using technology.
    As we expand, we welcome collaboration from engineers, developers, designers, and visionaries.
  </p>
  <p>
    If you're passionate about construction-tech and want to shape the future with us, send your interest to:
    <a href="mailto:konstructcyber@gmail.com" className="career-link"> careers@cyberkon.com </a>
  </p>
</section>

      </div>
    </div>
    <Footer/>
      </div>
  );
};

export default Team;
